import React, { Suspense } from "react";
import PrivateRoute from "./PrivateRoute";
import { ToastContainer } from "react-toastify";
import Home from "../components/SuperAdmin/Home/Home";
import { Navigate, Route, Routes } from "react-router-dom";
import LazyLoader from "../components/common/commonComponents/LazyLoader/LazyLoader";

const MyProfile = React.lazy(() => import("../components/MyProfile/MyProfile"));
const Completion = React.lazy(() => import("../pages/PropertyManager/BookingManagement/BookService/Completion"));
const BookingManagement = React.lazy(() => import("../pages/PropertyManager/BookingManagement/BookingManagement"));
const PropertyManagement = React.lazy(() => import("../pages/PropertyManager/PropertyManagement/PropertyManagement"));
const PaymentElement = React.lazy(() => import("../pages/PropertyManager/BookingManagement/BookService/PaymentElement"));
const PropertyManagerDashboard = React.lazy(() => import("../pages/PropertyManager/PropertyManagerDashboard/PropertyManagerDashboard"));
const AllActivities = React.lazy(() => import("../pages/SuperAdmin/AllAcitvities/AllActivities"));
const AllUpcomingBookings = React.lazy(() => import("../pages/PropertyManager/PropertyManagerDashboard/UpcomingBookings/AllUpcomingBookings"));

const PropertyManagerRoutes = ({ props }) => {
  const { loader } = props;

  return (
    <div className="main_container">
      <Suspense fallback={<LazyLoader />}>
      <Routes>
        <Route
          path="/home"
          exact
          element={
            <PrivateRoute>
              <Navigate replace to="/home/dashboard" />
            </PrivateRoute>
          }
        />

        <Route
          path="/home"
          exact
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        >
          {/* <Route path='/home' exact element={<Navigate replace to='/home/dashboard' />} /> */}
          <Route path="activity" exact element={<AllActivities />} />
          <Route
            path="upcomingBookings"
            exact
            element={<AllUpcomingBookings />}
          />

          <Route path="profile" exact element={<MyProfile />} />
          <Route
            path="dashboard"
            exact
            element={<PropertyManagerDashboard />}
          />
          <Route
            path="bookingManagement"
            exact
            element={<BookingManagement />}
          />
          <Route
            path="propertyManagement"
            exact
            element={<PropertyManagement />}
          />
          <Route path="payment" exact element={<PaymentElement />} />
          <Route path="completion" exact element={<Completion />} />

          {/* default path for auth routes */}
          <Route path="*" exact element={<Navigate to="dashboard" replace />} />
        </Route>

        {/* default redirection - without auth no pvt should hit... */}
        <Route
          path="*"
          element={
            <PrivateRoute>
              <Navigate replace to="/home/dashboard" />
            </PrivateRoute>
          }
        />
      </Routes>
      </Suspense>
      <ToastContainer position="top-right" />
    </div>
  );
};

export default PropertyManagerRoutes;
